<template>
  <div class="component-grid-quotes">
    <ul class="component-grid-quotes__grid">
      <li v-for="quote in quotes" :key="quote.id">
        <CardQuote :quote="quote"></CardQuote>
      </li>
    </ul>
    <img
      v-if="!isEmbedded"
      src="@/assets/components/landing/quotes-grid/pattern.svg"
      class="component-grid-quotes__pattern"
      alt=""
    />
  </div>
</template>
<script>
import CardQuote from '@/components/CardQuote'
export default {
  name: 'LandingQuotesGrid',
  components: { CardQuote },
  props: {
    quotes: {
      type: Array,
      default: () => {
        return []
      }
    },
    isEmbedded: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss">
.component-grid-quotes {
  position: relative;

  &__grid {
    position: relative;
    z-index: 2;
    margin: rem(-20px);
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;

    li {
      width: calc(50% - #{rem(40px)});
      flex: 0 0 calc(50% - #{rem(40px)});
      margin: rem(20px);

      &:nth-child(even) {
        margin-top: rem(80px);
        margin-bottom: rem(-80px);
      }

      @include media-breakpoint-down(sm) {
        width: calc(100% - #{rem(40px)});
        flex: 0 0 calc(100% - #{rem(40px)});

        &:nth-child(even) {
          margin: rem(20px);
        }
      }
    }
  }

  &__pattern {
    position: absolute;
    right: 25%;
    transform: translateX(50%);
    top: rem(490px);
    z-index: 1;

    @include media-breakpoint-down(lg) {
      top: rem(520px);
    }
    @include media-breakpoint-down(lg) {
    }
    @include media-breakpoint-down(md) {
      display: none;
      top: rem(490px);
    }
  }
}
</style>
